<div class="m-search-no-results {{ modifier && 'm-search-no-results--' + modifier || modifier }}"
	 data-t-name="SearchNoResults"
	 [attr.data-t-decorator]="decorator">
	<h2 class="m-search-no-results__no-result-headline">{{noResultsTitle}}</h2>
	<cov-richtext [text]="noResultsText"></cov-richtext>
	<cov-button
		*ngIf="showButton"
		[text]="buttonText"
		[modifier]="'primary'"
		(click)="btnClicked()">
	</cov-button>
</div>
